export default "__VITE_ASSET__gjhjA8Jb__"